import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './htmlViewer.scss';
import { decodeDocument } from '../utils/documentsHelper';

@CSSModules(styles, {allowMultiple: true})
export default class HtmlViewer extends React.Component {

  static propTypes = {
    content: PropTypes.string.isRequired
  };

  render() {
    if (!this.props.content) {
      return null;
    }

    /* eslint-disable react/no-danger */
    return (
      <div styleName="htmlViewer" dangerouslySetInnerHTML={{__html: decodeDocument(this.props.content)}}/>
    );
    /* eslint-enable react/no-danger */
  }
}



// WEBPACK FOOTER //
// ./src/pdf/HtmlViewer.js